import { ChangeDetectorRef, Component, Inject } from '@angular/core'
import { Account, AccountsRequestContext } from '@helios/generic-components'
import { HeliosServerSideRequest } from '@helios/server-side-util'
import { Subject } from 'rxjs'
import { take, takeUntil } from 'rxjs/operators'
import { AccountListService } from '../../services/account-list.service'

@Component({
  selector: 'hs-total-rows-status',
  template: `
    <span
      ><span>Rows: </span>
      <span class="value">{{ filteredRowCount }}</span></span
    >
  `,
  styleUrls: ['./total-rows-status.component.scss'],
  host: { class: 'hs-status-bar' },
})
export class TotalRowsStatusComponent {
  private readonly destroySubject$ = new Subject<void>()
  filteredRowCount = 0
  constructor(
    private readonly cd: ChangeDetectorRef,
    @Inject('RowCountRequestGetter')
    private readonly getRowCountRequest: () => HeliosServerSideRequest<
      Account,
      AccountsRequestContext
    >,
    private readonly accountListService: AccountListService,
  ) {}

  async updateCounts() {
    const request = this.getRowCountRequest()
    this.filteredRowCount = await this.accountListService
      .getAccountListCountForFilter(request)
      .pipe(takeUntil(this.destroySubject$), take(1))
      .toPromise()

    this.cd.detectChanges()
  }

  destroy() {
    this.destroySubject$.next()
    this.destroySubject$.complete()
  }
}
